(function ($) {
   const $bar = $('.section-announcement-bar');

   if ($bar.length) {
      const $swiper = $bar.find('.swiper');

      const eventsSwiper = new Swiper($swiper[0], {
         loop: true,
         direction: 'vertical',
         autoHeight: true,
         slidesPerView: 'auto',
         spaceBetween: 10,
         // allowTouchMove: false,
         // slidesPerView: 1,
         // height: 22,
         // effect: 'fade',
         // fadeEffect: {
         //    crossFade: true,
         // },
         speed: 700,
         // autoplay: {
         //    delay: 5000,
         //    pauseOnMouseEnter: true,
         //    reverseDirection: true,
         // },
      });
   }

   // $(function() {
   // 	console.log('ready');
   // });

   // $(window).on('load', function() {
   // 	console.log('load');
   // });
})(jQuery);
